var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 46,
    r: 46,
    fill: "#F5F6F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.9014 59.8C29.9609 59.8 29.1759 59.4964 28.5462 58.8892C27.9151 58.2806 27.5996 57.523 27.5996 56.6161V35.3838C27.5996 34.477 27.9151 33.7199 28.5462 33.1127C29.1759 32.5042 29.9609 32.2 30.9014 32.2H61.0978C62.0383 32.2 62.8233 32.5042 63.453 33.1127C64.0841 33.7199 64.3996 34.477 64.3996 35.3838V56.6161C64.3996 57.523 64.0848 58.28 63.4551 58.8872C62.824 59.4957 62.0383 59.8 61.0978 59.8H30.9014ZM45.9996 46.2267L62.3552 35.9161L61.7255 34.1714L45.9996 44.0285L30.2737 34.1714L29.6441 35.9161L45.9996 46.2267Z",
    fill: "#7F56D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerify);
export default __webpack_public_path__ + "static/media/verify.c6cc554a9c8a60140235a838e94bb7dc.svg";
export { ForwardRef as ReactComponent };